<template>
  <div class="row level-container mx-md-0">
    <div
      v-for="(item, index) in levels"
      :key="`legend-index-${index}`"
      class="col p-0 d-flex flex-column rounded"
    >
      <div class="d-flex flex-column">
        <div
          class="d-flex justify-content-center align-items-center py-1"
          :style="`background-color: ${item.color}`"
        >
          <div class="color-gray-7 font-16 font-weight-bold">
            {{ item.name }}
          </div>
        </div>
        <div
          class="border-color--gray-5 py-2 d-flex justify-content-center align-items-center .border-top--color-white"
          :style="{ 'background-color': item.selected ? item.color : '#fff' }"
        >
          <div
            class="level-container__radio cursor-pointer d-flex justify-content-center align-items-center"
            @click="onSelectHandler(item, index)"
          >
            <div
              v-if="item.selected"
              class="level-container__radio--selected"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <custom-error v-if="error" :message="error" variant="no-border mt-1" />
    </div>
  </div>
</template>

<script>
import CustomError from 'custom-error';

export default {
  name: 'ExecutionLevelSelector',
  components: {
    CustomError,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    error: {
      type: String,
      default: () => null,
    },
    executionLevelArchieved: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      levels: this.executionLevelArchieved,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.levels = this.levels.map((item) => ({
            ...item,
            selected: newVal.id == item.id,
          }));
        }
      },
    },
  },
  methods: {
    onSelectHandler(item, itemIndex) {
      this.levels = this.levels.map((item, index) => ({
        ...item,
        selected: itemIndex === index,
      }));
      this.$emit('input', item);
    },
  },
};
</script>

<style scoped lang="scss">
.level-container {
  display: flex;
  .col {
    padding: 0px 2px !important;
  }
  &__radio {
    border: 1px solid #e2e2e2;
    border-radius: 20px;
    width: 21px;
    height: 21px;
    &--selected {
      background: #2db782;
      width: 11px;
      height: 11px;
      border-radius: 50px;
    }
  }
}
</style>
